export { default } from './ChangeEmailConfirmNoticeBlock';



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/ChangeEmailConfirmNoticeBlock/index.js